// Keeps local freshness checks active only while the page is visible.
export const subscribeVisibleFreshness = (documentRef, timers, onTick) => {
  let intervalId = null;
  let subscribed = true;
  const stop = () => {
    if (intervalId !== null) {
      timers.clearInterval(intervalId);
      intervalId = null;
    }
  };
  const sync = () => {
    if (!subscribed) return;
    if (documentRef.visibilityState !== 'visible') {
      stop();
      return;
    }
    onTick();
    if (intervalId === null) intervalId = timers.setInterval(onTick, 5000);
  };
  documentRef.addEventListener('visibilitychange', sync);
  sync();
  return () => {
    subscribed = false;
    documentRef.removeEventListener('visibilitychange', sync);
    stop();
  };
};

export const localFreshnessExpired = (freshness, now) => (
  !freshness || !Number.isFinite(freshness.receivedAt)
  || !Number.isFinite(freshness.duration) || freshness.duration <= 0
  || freshness.duration > 45000 || !Number.isFinite(now)
  || now - freshness.receivedAt >= freshness.duration
  || now < freshness.receivedAt
);
